import { useGetMeQuery } from '@/service/user/user.hook';
import { isDemoMode } from '@/utils/demo-mode';
import { useTranslation } from 'react-i18next';

/**
 * Verrou de démonstration : vrai quand la session tourne sur le compte de
 * démonstration du site vitrine, donc quand aucune écriture n'aboutira.
 *
 * L'autorité est `user.isDemo`, calculé par le serveur. Le flag local ne sert
 * qu'avant l'arrivée de la réponse : il est posé par le client lui-même, donc
 * falsifiable, et ne doit jamais décider seul.
 */
export function useDemoLock(): boolean {
  const { data: user } = useGetMeQuery();
  if (user) return user.isDemo === true;
  return isDemoMode();
}

/**
 * Props à étaler sur une commande d'écriture : elle devient grise, inerte et
 * annoncée comme telle aux lecteurs d'écran.
 */
export function useDemoLockProps(): {
  disabled?: boolean;
  'aria-disabled'?: true;
  title?: string;
} {
  const { t } = useTranslation();
  const locked = useDemoLock();
  if (!locked) return {};
  return {
    disabled: true,
    'aria-disabled': true,
    title: t('demo.lockedTitle'),
  };
}
